import type { WidgetProps } from "@rjsf/utils";
import React from "react";
import type { PropsWithChildren } from "react";
import * as styles from "./InformationBox.module.scss";

type PropsUnion =
	| PropsWithChildren<{ helpText?: never }>
	| { helpText: string; children?: never };

type Props = WidgetProps<
	PropsUnion & {
		isVisible?: boolean;
	}
>;
export const InformationBox: React.FC<Props> = ({
	helpText,
	isVisible = true,
	children,
	...aerInfoBoxProps
}) => {
	if ((!helpText && !children && !aerInfoBoxProps.schema?.title) || !isVisible)
		return null;
	if (helpText?.length > 0) {
		return (
			<div
				className={
					aerInfoBoxProps.uiSchema["ui:options"]?.background
						? styles.informationbox
						: styles.clearinformationbox
				}
				// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
				dangerouslySetInnerHTML={{
					__html: helpText,
				}}
			/>
		);
	}
	if (aerInfoBoxProps.schema?.title?.length > 0) {
		return (
			<div
				className={
					aerInfoBoxProps.uiSchema["ui:options"]?.background
						? styles.informationbox
						: styles.clearinformationbox
				}
				// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
				dangerouslySetInnerHTML={{
					__html: aerInfoBoxProps.schema?.title,
				}}
			/>
		);
	}
	return (
		<div
			className={
				aerInfoBoxProps.uiSchema["ui:options"]?.background
					? styles.informationbox
					: styles.clearinformationbox
			}
		>
			{children}
		</div>
	);
};
export default InformationBox;
